import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbProps {
  items: { label: string; href?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://timelynews.github.io${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <span key={index} className="flex items-center gap-1.5">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              )}
              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="hover:text-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'text-foreground-800 font-medium' : 'text-foreground-500'}>
                  {item.label}
                </span>
              )}
            </span>
          );
        })}
      </nav>
    </>
  );
}

export function getCategoryBreadcrumb(slug: string) {
  const cat = categories.find((c) => c.slug === slug);
  return [
    { label: '首页', href: '/' },
    { label: cat?.name || '分类' },
  ];
}

export function getArticleBreadcrumb(categorySlug: string, categoryName: string, articleTitle: string) {
  return [
    { label: '首页', href: '/' },
    { label: categoryName, href: `/category/${categorySlug}` },
    { label: articleTitle },
  ];
}